import * as React from 'react';
import {LessonObject} from 'api/lesson/types';
import LessonViewerContext, {
  LessonViewerContextValue,
} from './LessonViewerContext';
import Header from './components/Header';
import Content from './components/Content';

export type LessonViewerProps
  = LessonObject;

/**
 * This is the lesson viewing component.
 * @param {LessonViewerProps} props
 * @return {React.ReactElement<LessonViewerProps>}
 * @constructor
 */
export default function LessonViewer(
    props: LessonViewerProps,
): React.ReactElement<LessonViewerProps> {
  const {Provider} = LessonViewerContext;

  /**
   * Get the context value
   * @return {LessonViewerContextValue}
   */
  function getContextValue(): LessonViewerContextValue {
    return props;
  }

  return (
    <Provider value={getContextValue()}>
      <div>
        <Header />
        <Content />
      </div>
    </Provider>
  );
}
